import React, {Component} from 'react';
import '../css/Heading.css';
import logo from '../img/daikin_logo.png';

class Heading extends Component {
	render() {
		let width = this.props.dimensions.width;
		const classes = (width >= 684 )
		? "app__header app__emco-wide"
		: "app__header";

		return (
			<div className={classes}>
				<div className="app__responsive-wrap app__emco_col_6">
					<img src={logo} alt="Daikin Atlantic"/>
					<h2>{this.props.content.title}</h2>
				</div>
				<div className="app__responsive-wrap app__emco_col_6">
					<p>{this.props.content.headtext}</p>
				</div>
			</div>
		);
	}
}

export default Heading;



// WEBPACK FOOTER //
// ./src/components/Heading.js